import * as React from 'react'

const SvgCaretSortIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 7.5L10 2.5l4.375 5h-8.75zm8.75 5L10 17.5l-4.375-5h8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCaretSortIcon
